import { LEGACY_MY_ACCOUNT_PAGES } from 'constants/links';
import { catVantageRewardCopyright } from '../../account/(with-nav)/rewards/_constants/constants';

export const CONTROL_CENTER = {
  label: 'CONTROL_CENTER',
  helperText: 'DESC_CONTROL_CENTER',
  route: LEGACY_MY_ACCOUNT_PAGES.CONTROL_CENTER
};
export const PERSONAL_INFO = {
  label: 'PERSONAL_INFO',
  helperText: 'DESC_PERSONAL_INFO',
  route: LEGACY_MY_ACCOUNT_PAGES.PERSONAL_INFORMATION
};
export const MY_EQUIPMENT = {
  label: 'MY_EQUIP',
  helperText: 'DESC_MY_EQUIP',
  route: LEGACY_MY_ACCOUNT_PAGES.EQUIPMENT
};
export const ORDER_HISTORY = {
  label: 'CAT_ORDER_HISTORY',
  helperText: 'DESC_ORDER_INFO',
  route: LEGACY_MY_ACCOUNT_PAGES.ORDERS
};
export const ORDERS_TO_APPROVE = {
  label: 'MYACCOUNT_ORDER_APPROVAL',
  helperText: 'DESC_ORDERS_TO_APPROVE',
  route: LEGACY_MY_ACCOUNT_PAGES.ORDERS_TO_APPROVE
};
export const PENDING_QUOTES = {
  label: 'QUOTES',
  helperText: 'DESC_PENDING_QUOTES',
  route: LEGACY_MY_ACCOUNT_PAGES.PENDINGQUOTES
};
export const SAVED_LISTS = {
  label: 'SAVED_LISTS',
  helperText: 'DESC_SAVED_LISTS',
  route: LEGACY_MY_ACCOUNT_PAGES.LISTS
};
export const NOTIFICATION_PREFERENCES = {
  label: 'CAT_NOTIFICATION_PREFERENCES_TITLE',
  helperText: 'DESC_NOTIF_PREFERENCES'
};
export const SHOPPING_PREFERENCES = {
  label: 'CAT_SHOPPING_PREFERENCES_TITLE',
  helperText: 'DESC_SHOPPING_PREFERENCES',
  route: LEGACY_MY_ACCOUNT_PAGES.PREFERENCES
};
export const ADDRESS_BOOK = {
  label: 'MA_ADDRESS_BOOK',
  helperText: 'DESC_ADDRESS_BOOK',
  route: LEGACY_MY_ACCOUNT_PAGES.ADDRESS_BOOK
};

export const CAT_VANTAGE_REWARDS = {
  label: catVantageRewardCopyright,
  helperText: 'GET_REWARDED_EARN_CAT_VANTAGE_POINTS',
  route: LEGACY_MY_ACCOUNT_PAGES.CAT_VANTAGE_REWARDS
};

export const CUSTOMER_CARE_LANDING_PAGE = {
  label: 'Cat Customer Care Home',
  helperText: 'Search by customer or order'
};

export const CUSTOMER_CARE_TRANSACT_GUEST = {
  label: 'Transact As Guest',
  helperText: 'Transact on behalf of a guest customer'
};

export const PRODUCT_CATEGORY_PARAMS = {
  subCategoryLevel: '3',
  subCategoryLimit: '30'
};
export const INVOICE_SEARCH_PAGE = {
  label: 'INVOICE_MENU',
  helperText: 'INVOICE_MENU_VERBIAGE',
  route: LEGACY_MY_ACCOUNT_PAGES.INVOICES
};

export const hideStickyHeaderPage = ['/cart'];

export const hideEquipmentInfoHeader = [
  { key: '/service-recommendations/', id: 'id' }
];

export const DEALER_SEARCH_VALUES = ['PartStore123', 'RockLand123'];
